import { Breadcrumbs, Button, Chip, CircularProgress } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { emphasize, styled } from "@mui/material/styles";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MyContext } from "../../App";
import { editData, editFeilds, fetchDataFromApi } from "../../utils/api";
import { FaCloudUploadAlt } from "react-icons/fa";

//breadcrump code
const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === "light"
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
});

const EditVariantGroup = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [formFields, setFormFields] = useState({
    name: "",
  });

  let { id } = useParams();

  const history = useNavigate();

  const context = useContext(MyContext);

  useEffect(() => {
    window.scrollTo(0, 0);

    context.setProgress(20);
    fetchDataFromApi(`/api/variantGroup/${id}`).then((res) => {
      setFormFields({
        name: res.name,
      });
      context.setProgress(100);
    });
  }, []);

  const changeInput = (e) => {
    setFormFields(() => ({
      ...formFields,
      [e.target.name]: e.target.value,
    }));
  };

  const editVariantGroup = (e) => {
    e.preventDefault();

    if (formFields.name === "") {
      context.setAlertBox({
        open: true,
        error: true,
        msg: "Please fill name",
      });
      return;
    }
    setIsLoading(true);

    try {
      editFeilds(`/api/variantGroup/${id}`, formFields).then((res) => {
        if (res.error !== true) {
          context.setAlertBox({
            open: true,
            error: false,
            msg: "The variantGroup is updated!",
          });
          setIsLoading(false);
          history("/variantGroup");
        } else {
          setIsLoading(false);
          context.setAlertBox({
            open: true,
            error: true,
            msg: res.msg,
          });
          setIsLoading(false);
          history("/variantGroup");
        }
      });
    } catch (error) {
      setIsLoading(false);
      context.setAlertBox({
        open: true,
        error: true,
        msg: "An unexpected error occurred",
      });
    }
  };

  return (
    <>
      <div className="right-content w-100">
        <div className="card shadow border-0 w-100 flex-row p-4 mt-2 res-col">
          <h5 className="mb-4">Edit Category</h5>
          <Breadcrumbs aria-label="breadcrumb" className="ml-auto breadcrumbs_">
            <StyledBreadcrumb
              component="a"
              href="#"
              label="Dashboard"
              icon={<HomeIcon fontSize="small" />}
            />
            <StyledBreadcrumb
              component="a"
              href="#"
              label="Variant Group"
              deleteIcon={<ExpandMoreIcon />}
            />
            <StyledBreadcrumb
              label="Edit Variant Group"
              deleteIcon={<ExpandMoreIcon />}
            />
          </Breadcrumbs>
        </div>

        <form className="form" onSubmit={editVariantGroup}>
          <div className="row">
            <div className="col-sm-9">
              <div className="card p-4 mt-0">
                <div className="form-group">
                  <h6>Variant Group Name</h6>
                  <input
                    type="text"
                    name="name"
                    value={formFields.name}
                    onChange={changeInput}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="card p-4 mt-0">
            <Button type="submit" className="btn-blue btn-lg btn-big w-100">
              <FaCloudUploadAlt /> &nbsp;
              {isLoading === true ? (
                <CircularProgress color="inherit" className="loader" />
              ) : (
                "PUBLISH AND VIEW"
              )}
            </Button>
          </div>
        </form>
      </div>
    </>
  );
};

export default EditVariantGroup;
